import React from "react";

type ImportantIconProps = {
  width?: number;
  height?: number;
  className?: string;
};

const ImportantIcon = ({
  width = 16,
  height = 16,
  className,
}: ImportantIconProps) => (
  <svg
    style={{minWidth: width, minHeight: height}}
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1263_64123)">
      <path
        d="M7.33337 4.66732H8.66671V6.00065H7.33337V4.66732ZM7.33337 7.33398H8.66671V11.334H7.33337V7.33398ZM8.00004 1.33398C4.32004 1.33398 1.33337 4.32065 1.33337 8.00065C1.33337 11.6807 4.32004 14.6673 8.00004 14.6673C11.68 14.6673 14.6667 11.6807 14.6667 8.00065C14.6667 4.32065 11.68 1.33398 8.00004 1.33398ZM8.00004 13.334C5.06004 13.334 2.66671 10.9407 2.66671 8.00065C2.66671 5.06065 5.06004 2.66732 8.00004 2.66732C10.94 2.66732 13.3334 5.06065 13.3334 8.00065C13.3334 10.9407 10.94 13.334 8.00004 13.334Z"
        fill="#FF9800"
      />
    </g>
    <defs>
      <clipPath id="clip0_1263_64123">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ImportantIcon;
